import React, { useEffect, useState } from 'react'
import Header from '../Components/Header'
import Modal from 'react-modal';
import dailyIframe from '@daily-co/daily-js';


import kid1 from '../img/grid/kid_1.jpg'

import kid2 from '../img/grid/kid_2.jpg'
import kid3 from '../img/grid/kid_3.jpg'
import kid4 from '../img/grid/kid_4.jpg'
import kid5 from '../img/grid/kid_5.jpg'

import kid6 from '../img/grid/kid_6.jpg'


import small1 from '../img/grid/grid_small_1.jpg'
import { ClipLoader, MoonLoader } from 'react-spinners';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width: "80%",
    height: "80%",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1001,
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
};

Modal.setAppElement('#root');

const API_KEY = process.env.REACT_APP_DAILY_API_KEY;
const DAILY_API_URL = process.env.REACT_APP_DAILY_API_URL;





const Home = () => {

  const [isInCall, setIsInCall] = useState(false);
  const [dailyCall, setDailyCall] = useState(null);
  const [loading, setLoading] = useState(false);


  const [showEndCallButton, setShowEndCallButton] = useState(true);
  const [showIframe, setShowIframe] = useState(false);

  const [messageIndex, setMessageIndex] = useState(0);

  const messages = [
    "Please wait while we connect you...",
    "Hang on tight...",
    "We are almost there..."
  ];


  useEffect(() => {
    const interval = setInterval(() => {
      if (messageIndex < messages.length - 1) {
        setMessageIndex(prevIndex => prevIndex + 1);
      }
    }, 3300); 

    // Simulate iframe loading completion
    const loadingTimeout = setTimeout(() => {
      setLoading(false); 
      clearInterval(interval);
    }, 8000);

    return () => {
      clearInterval(interval);
      clearTimeout(loadingTimeout);
    };
  }, [messageIndex]);

  const [selectedGrade, setSelectedGrade] = useState('All');

  const checkIfRoomExists = async (roomName) => {
    try {
      const response = await fetch(`${DAILY_API_URL}/${roomName}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${API_KEY}`,
        },
      });
      if (response.status === 200) {
        const data = await response.json();
        return data.url;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error checking room:', error);
      return null;
    }
  };

  const createDailyRoom = async (roomName) => {
    try {
      setLoading(true);
      const response = await fetch(DAILY_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${API_KEY}`, // Use your API key
        },
        body: JSON.stringify({
          name: roomName,
          properties: {
            enable_knocking: true, // Allow participants to request entry
            exp: Math.round(Date.now() / 1000) + 3600, // Room expires in 1 hour
          },
        }),
      });

      const data = await response.json();
      if (data.url) {
        return data.url;
      } else {
        throw new Error('Failed to create the meeting room.');
      }
    } catch (error) {
      console.error('Error creating room:', error);
      return null;
    } finally {
      setLoading(false);
    }
  };


  const startDailyMeeting = async (roomName) => {
    setLoading(true);

    let roomUrl = await checkIfRoomExists(roomName);
    if (!roomUrl) {
      roomUrl = await createDailyRoom(roomName);
    }

    if (roomUrl) {
      const callFrame = dailyIframe.createFrame({
        iframeStyle: {
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          top: 0,
          left: 0,
          border: '0',
          zIndex: 9999,
          display: 'none',
        },
      });

      callFrame.join({
        url: roomUrl,
        userName: 'Student',
      });

      setDailyCall(callFrame);
      setIsInCall(true);

      callFrame.on('loaded', () => {
        // Delay showing the iframe for an extra 3 seconds
        setTimeout(() => {
          setLoading(false);
          setShowIframe(true);
          callFrame.iframe().style.display = 'block';
        }, 4000); 
      });
    } else {
      setLoading(false);
    }
  };




  const endCall = () => {
    if (dailyCall) {
      dailyCall.leave(); // Leave the call
      dailyCall.destroy(); // Clean up the iframe
    }
    setIsInCall(false); // Switch back to showing the grid items
  };

  const filterItems = (grade) => {
    setSelectedGrade(grade);
  };


  useEffect(() => {
    let hideButtonTimeout;

    const handleMouseMove = () => {
      setShowEndCallButton(true);
      clearTimeout(hideButtonTimeout);
      hideButtonTimeout = setTimeout(() => {
        setShowEndCallButton(false);
      }, 2000);
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      clearTimeout(hideButtonTimeout);
    };
  }, []);



  return (
    <div>


{loading && (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <MoonLoader size={60} color={"#01989e"} loading={loading} /> 
          <p style={{ marginTop: '20px', fontSize: '16px', color: '#333' }}>
            {messages[messageIndex]}
          </p>
        </div>
      )}

 {!isInCall && (
        <div className="gridarea sp_bottom_100 sp_top_80" data-aos="fade-up">
          <div className="container">
            <div className="row" data-aos="fade-up">
              <div className="col-xl-12">
                <div className="gridfilter_nav grid__filter gridFilter">
                  <button onClick={() => filterItems('All')} className={selectedGrade === 'All' ? 'active' : ''}>All</button>
                  <button onClick={() => filterItems('Grade 11')} className={selectedGrade === 'Grade 11' ? 'active' : ''}>Grade 11</button>
                  <button onClick={() => filterItems('Grade 12')} className={selectedGrade === 'Grade 12' ? 'active' : ''}>Grade 12</button>
                </div>
              </div>
            </div>
            <div className="row grid">
              {(selectedGrade === 'All' || selectedGrade === 'Grade 11') && (
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 grid-item">
              <div class="gridarea__wraper">
                  <div class="gridarea__img">
                      <a  onClick={() => startDailyMeeting('grade-11-technology')}>
                          <img loading="lazy" src={kid1} alt="grid" />
                      </a>
                      <div class="gridarea__small__button">
                          <div class="grid__badge">Grade 11</div>
                      </div>
                      <div class="gridarea__small__icon">
                          <a href='javascript:void(0)'><i class="icofont-heart-alt"></i></a>
                      </div>
                  </div>
                  <div class="gridarea__content">
                      <div class="gridarea__list">
                        
                      </div>
                      <div class="gridarea__heading">
                          <h3><a onClick={() => startDailyMeeting('grade-11-technology')}> Technology</a></h3>
                      </div>
                      <div class="gridarea__price">
                          <a  onClick={() => startDailyMeeting('grade-11-technology')} href='javascript:void(0)'>Join Class</a>
                      </div>
                      <div class="gridarea__bottom">
                          <a href="">
                              <div class="gridarea__small__img">
                                  <img loading="lazy" src={small1} alt="grid" />
                                  <div class="gridarea__small__content">
                                      <h6>Micle Jhon</h6>
                                  </div>
                              </div>
                          </a>
                          <div class="gridarea__star">
                              <i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><span>(44)</span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
              )}

{(selectedGrade === 'All' || selectedGrade === 'Grade 12') && (
                 <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 grid-item" >
                 <div class="gridarea__wraper">
                     <div class="gridarea__img">
                         <a onClick={() => startDailyMeeting('grade-12-english')}>
                             <img loading="lazy" src={kid5} alt="grid" />
                         </a>
                         <div class="gridarea__small__button">
                             <div class="grid__badge pink__color">Grade 12</div>
                         </div>
                         <div class="gridarea__small__icon">
                             <a href='javascript:void(0)'><i class="icofont-heart-alt"></i></a>
                         </div>
                     </div>
                     <div class="gridarea__content">
                         <div class="gridarea__list">
                           
                         </div>
                         <div class="gridarea__heading">
                             <h3><a onClick={() => startDailyMeeting('grade-12-english')}>English</a></h3>
                         </div>
                         <div class="gridarea__price">
                             <a onClick={() => startDailyMeeting('grade-12-english')} href='javascript:void(0)'>Join Class</a>
                         </div>
                         <div class="gridarea__bottom">
                             <a href="">
                                 <div class="gridarea__small__img">
                                     <img loading="lazy" src={small1} alt="grid" />
                                     <div class="gridarea__small__content">
                                         <h6>Micle Jhon</h6>
                                     </div>
                                 </div>
                             </a>
                             <div class="gridarea__star">
                                 <i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><span>(44)</span>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
         
              )}

              {(selectedGrade === 'All' || selectedGrade === 'Grade 12') && (
             <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 grid-item" >
             <div class="gridarea__wraper">
                 <div class="gridarea__img">
                     <a onClick={() => startDailyMeeting('grade-12-mathematics')}>
                         <img loading="lazy" src={kid2} alt="grid" />
                     </a>
                     <div class="gridarea__small__button">
                         <div class="grid__badge yellow__color">Grade 12</div>
                     </div>
                     <div class="gridarea__small__icon">
                         <a href='javascript:void(0)'><i class="icofont-heart-alt"></i></a>
                     </div>
                 </div>
                 <div class="gridarea__content">
                     <div class="gridarea__list">
                      
                     </div>
                     <div class="gridarea__heading">
                         <h3><a onClick={() => startDailyMeeting('grade-12-mathematics')}>Mathemetics</a></h3>
                     </div>
                     <div class="gridarea__price">
                         <a onClick={() => startDailyMeeting('grade-12-mathematics')} href='javascript:void(0)'>Join Class</a>
                     </div>
                     <div class="gridarea__bottom">
                         <a href="">
                             <div class="gridarea__small__img">
                                 <img loading="lazy" src={small1} alt="grid" />
                                 <div class="gridarea__small__content">
                                     <h6>Micle Jhon</h6>
                                 </div>
                             </div>
                         </a>
                         <div class="gridarea__star">
                             <i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><span>(44)</span>
                         </div>
                     </div>
                 </div>
             </div>
         </div>
              )}

              {(selectedGrade === 'All' || selectedGrade === 'Grade 11') && (
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 grid-item" >
                <div class="gridarea__wraper">
                    <div class="gridarea__img">
                        <a onClick={() => startDailyMeeting('grade-11-english')}>
                            <img loading="lazy" src={kid3} alt="grid" />
                        </a>
                        <div class="gridarea__small__button">
                            <div class="grid__badge">Grade 11</div>
                        </div>
                        <div class="gridarea__small__icon">
                            <a href='javascript:void(0)'><i class="icofont-heart-alt"></i></a>
                        </div>
                    </div>
                    <div class="gridarea__content">
                        <div class="gridarea__list">
                          
                        </div>
                        <div class="gridarea__heading">
                            <h3><a onClick={() => startDailyMeeting('grade-11-english')}>English</a></h3>
                        </div>
                        <div class="gridarea__price">
                            <a onClick={() => startDailyMeeting('grade-11-english')} href='javascript:void(0)'>Join Class</a>
                        </div>
                        <div class="gridarea__bottom">
                            <a href="">
                                <div class="gridarea__small__img">
                                    <img loading="lazy" src={small1} alt="grid" />
                                    <div class="gridarea__small__content">
                                        <h6>Micle Jhon</h6>
                                    </div>
                                </div>
                            </a>
                            <div class="gridarea__star">
                                <i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><span>(44)</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        
              )}

              {(selectedGrade === 'All' || selectedGrade === 'Grade 12') && (
           <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 grid-item" >
           <div class="gridarea__wraper">
               <div class="gridarea__img">
                   <a onClick={() => startDailyMeeting('grade-12-science')}>
                       <img loading="lazy" src={kid4} alt="grid" />
                   </a>
                   <div class="gridarea__small__button">
                       <div class="grid__badge green__color">Grade 12</div>
                   </div>
                   <div class="gridarea__small__icon">
                       <a href='javascript:void(0)'><i class="icofont-heart-alt"></i></a>
                   </div>
               </div>
               <div class="gridarea__content">
                   <div class="gridarea__list">
                      
                   </div>
                   <div class="gridarea__heading">
                       <h3><a onClick={() => startDailyMeeting('grade-12-science')}>Science</a></h3>
                   </div>
                   <div class="gridarea__price">
                       <a onClick={() => startDailyMeeting('grade-12-science')} href='javascript:void(0)'>Join Class</a>
                   </div>
                   <div class="gridarea__bottom">
                       <a href="">
                           <div class="gridarea__small__img">
                               <img loading="lazy" src={small1} alt="grid" />
                               <div class="gridarea__small__content">
                                   <h6>Micle Jhon</h6>
                               </div>
                           </div>
                       </a>
                       <div class="gridarea__star">
                           <i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><span>(44)</span>
                       </div>
                   </div>
               </div>
           </div>
       </div>
   
              )}

{(selectedGrade === 'All' || selectedGrade === 'Grade 11') && (
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 grid-item" >
                <div class="gridarea__wraper">
                    <div class="gridarea__img">
                        <a onClick={() => startDailyMeeting('grade-11-science')}>
                            <img loading="lazy" src={kid3} alt="grid" />
                        </a>
                        <div class="gridarea__small__button">
                            <div class="grid__badge">Grade 11</div>
                        </div>
                        <div class="gridarea__small__icon">
                            <a href='javascript:void(0)'><i class="icofont-heart-alt"></i></a>
                        </div>
                    </div>
                    <div class="gridarea__content">
                        <div class="gridarea__list">
                          
                        </div>
                        <div class="gridarea__heading">
                            <h3><a onClick={() => startDailyMeeting('grade-11-science')}>Science</a></h3>
                        </div>
                        <div class="gridarea__price">
                            <a onClick={() => startDailyMeeting('grade-11-science')} href='javascript:void(0)'>Join Class</a>
                        </div>
                        <div class="gridarea__bottom">
                            <a href="">
                                <div class="gridarea__small__img">
                                    <img loading="lazy" src={small1} alt="grid" />
                                    <div class="gridarea__small__content">
                                        <h6>Micle Jhon</h6>
                                    </div>
                                </div>
                            </a>
                            <div class="gridarea__star">
                                <i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><span>(44)</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        
              )}

              {(selectedGrade === 'All' || selectedGrade === 'Grade 12') && (
                 <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 grid-item" >
                 <div class="gridarea__wraper">
                     <div class="gridarea__img">
                         <a onClick={() => startDailyMeeting('grade-12-technology')}>
                             <img loading="lazy" src={kid5} alt="grid" />
                         </a>
                         <div class="gridarea__small__button">
                             <div class="grid__badge pink__color">Grade 12</div>
                         </div>
                         <div class="gridarea__small__icon">
                             <a href='javascript:void(0)'><i class="icofont-heart-alt"></i></a>
                         </div>
                     </div>
                     <div class="gridarea__content">
                         <div class="gridarea__list">
                           
                         </div>
                         <div class="gridarea__heading">
                             <h3><a onClick={() => startDailyMeeting('grade-12-technology')}>Technology</a></h3>
                         </div>
                         <div class="gridarea__price">
                             <a onClick={() => startDailyMeeting('grade-12-technology')} href='javascript:void(0)'>Join Class</a>
                         </div>
                         <div class="gridarea__bottom">
                             <a href="">
                                 <div class="gridarea__small__img">
                                     <img loading="lazy" src={small1} alt="grid" />
                                     <div class="gridarea__small__content">
                                         <h6>Micle Jhon</h6>
                                     </div>
                                 </div>
                             </a>
                             <div class="gridarea__star">
                                 <i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><span>(44)</span>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
         
              )}

              {(selectedGrade === 'All' || selectedGrade === 'Grade 11') && (
               <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 grid-item" >
        <div class="gridarea__wraper">
            <div class="gridarea__img">
                <a onClick={() => startDailyMeeting('grade-11-mathemetics')}>
                    <img loading="lazy" src={kid6} alt="grid" />
                </a>
                <div class="gridarea__small__button">
                    <div class="grid__badge blue__color">Grade 11</div>
                </div>
                <div class="gridarea__small__icon">
                    <a href='javascript:void(0)'><i class="icofont-heart-alt"></i></a>
                </div>
            </div>
            <div class="gridarea__content">
                <div class="gridarea__list">
                  
                </div>
                <div class="gridarea__heading">
                    <h3><a onClick={() => startDailyMeeting('grade-11-mathemetics')}>Mathemetics</a></h3>
                </div>
                <div class="gridarea__price">
                    <a onClick={() => startDailyMeeting('grade-11-mathemetics')} href='javascript:void(0)'>Join Class</a>
                </div>
                <div class="gridarea__bottom">
                    <a href="">
                        <div class="gridarea__small__img">
                            <img loading="lazy" src={small1} alt="grid" />
                            <div class="gridarea__small__content">
                                <h6>Micle Jhon</h6>
                            </div>
                        </div>
                    </a>
                    <div class="gridarea__star">
                        <i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><i class="icofont-star"></i><span>(44)</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

              )}
            </div>
          </div>
        </div>
      )}

{isInCall && (
        <button
          style={{
            position: 'absolute',
            top: 80,
            left: 20,
            zIndex: 10000,
            padding: '10px 20px',
            backgroundColor: 'red',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
          }}
          onClick={endCall}
        >
          End Call
        </button>
      )}
      {loading && <p>Creating the meeting room...</p>}
   
    </div>
  )
}

export default Home
 